import React, { useState, useEffect, useCallback }      from "react";
import { useDispatch, useSelector }                     from 'react-redux'
import { OverlayTrigger, Tooltip }                      from "react-bootstrap";
import { ClipLoader }                                   from "react-spinners";
import { arrayToHex }                                   from "eosjs/dist/eosjs-serialize";
import * as _actions                                    from "actions";

import { useEthereum, chains, findByChainId, rules, shortenAddress }    from 'helpers/EthereumContext.js' 
import QUDOServer                                       from 'helpers/QUDOServerConnection';
import * as MK                                          from 'helpers/metakeep.js'
import { confirmAmount, getFloat, ceil, floor, round, olderThan }                      from "helpers/utils";

import { MessageModal }                                 from "components/components/modals/modals";
import WalletImportTutorial                             from "components/common/walletMigration/walletImportTutorial";

import { Modal }    from "react-bootstrap";
import { eligleForMetakeep } from "helpers/betasEliglebles";
import cssColors from "helpers/cssColors";
import useWindowSize from "helpers/useWindowSize";

const EXECUTEDMSG = 'done'
const CURREXECMSG = 'in progress'
const WAITEXECMSG = ''

const send  = require("images/definitive/icn-send-qudos.png");
const arrow = require("images/definitive/icn-arrow-forward.png");

const minBridgeBalance = 1

const knowMoreTooltip = (
    <Tooltip placement="top" className="">
        <span className="text-light"><small>
            Fees are based on your staked amount (held 30+ days, up to 50%) relative to your total balance
        </small></span>
    </Tooltip>
);

export const FUNC = Object.freeze({
    PRINT_NETWORK:      'printNetwork',     ///  for debugging
    SWITCH_NETWORK:     'switchNetwork',    ///  eth.switchNetwork           arg[0] = chainId
    PERMISSION:         'permission',       ///  eth.permissionToBridgeBack  arg[0] = amount
    BRIDGE:             'bridge',           ///  eth.ethersBridge            arg[0] = receiver  arg[1] = amount    arg[2] = chainId
    BRIDGE_BACK:        'bridgeBack',       ///  eth.ethersBridgeBack        arg[0] = amount    arg[1] = receiver  
    WAIT_BALANCE:       'waitBalance',      ///  wait enough balance         arg[0] = amount    arg[1] = chainId
    MIN_CHAIN_BALANCE:  'minChainBalance,'  ///  min of native currency      arg[0] = minNative arg[1] = chainId
});

function createAction({
    completed   = false,        // if the action is completed, set by the function
    message     = '',           // message to display in the modal - optional, empty is hidden
    func        = 'unknown',    // function to call, from FUNC.
    args        = [],           // arguments to pass to the function
    error       = null,         // save the new Error.message here
    options     = {}            // specific options for the function, you can also write here for 'permanent' information
    /* options include like:
        - source_chainId    (by: BRIDGE, MIN_CHAIN_BALANCE)
        - timeout           (by: WAIT_BALANCE)
        - stopped           (by: WAIT_BALANCE)
        - success_message   (by: all)
            For - setModalMessage(options['success_message']); setSuccessModal(true); - when it finishes
        - error_message     (by: MIN_CHAIN_BALANCE)
            For - display this message if it fails
    */
} = {}) {
    return { completed, message, func, args, options };
}


export default function Transfer({
	chainId			        = 0,     // Chain ID for the opened chain, where we execute actions / 0 = Telos Zero
    detailColor,	                 // Background shadow color
}) {
    const dispatch  = useDispatch()
    const eth       = useEthereum()
    const isEVM     = chainId !== 0
    const chain     = findByChainId(chainId)
    const windowSize= useWindowSize();
    const isMobile  = (windowSize && windowSize.width < 840);

    const ual           = useSelector(state => state.ual)
    const balance       = useSelector(state => state.balance)
    const currentUser   = useSelector(state => state.info)
    
    const disabled   = currentUser.qudoManaged // grayedout if disabled
    console.log("Transfer disabled", disabled)
    
    const localStorageKey                       = `Transfer`  //-${chainId}   // this is also used in logout of layout
    const [lockedTransfer, setLockedTransfer]   = useState(false)
    const [loading, setLoading]                 = useState(false)
    const [submitting, setSubmitting]           = useState(false)
    const [modalMessage, setModalMessage]       = useState('')
    const [successModal, setSuccessModal]       = useState(false)
    const [failureModal, setFailureModal]       = useState(false)
    const [errorMessage, setErrorMessage]       = useState('')
    const [tutorialModal, setTutorialModal]     = useState(false)
    const [knowMoreModal, setKnowMoreModal]     = useState(false)
    
    const [chainSelected, setChainSelected] = useState(-1)
    const [maxBalance, setMaxBalance]       = useState(0)
    const [quantity, setQuantity]           = useState(0)
    const [preFeeQty, setPreFeeQty]         = useState(0)
    const [fee, setFee]                     = useState(50)
    const [feeQty, setFeeQty]               = useState(0)
    
    const [actionsList, setActionsList]     = useState([])
    const [actionsPaused, setActionsPaused] = useState(true)
    const [actionsModal, setActionsModal]   = useState(false)
    const [unfinishedActions, setUnfinishedActions] = useState(false)

    

    let currentExecution = actionsList.findIndex( action => action.completed === false );
    if( currentExecution < 0  ) currentExecution = actionsList.length

    // MARK: Hooks

    useEffect(() => {
        const _actions = JSON.parse( localStorage.getItem( localStorageKey, JSON.stringify(actionsList) ) )
        console.debug("Read actions from localstorage", _actions)
        if(     _actions 
            &&  Array.isArray(_actions)
            &&  _actions.length>0
            &&  _actions.findIndex(a=>a.completed===false) 
          ){
            setUnfinishedActions(true)
            setActionsModal(true)
            setActions(_actions)
        }
        updateBalance();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        updateBalance();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [balance.balance, eth.balances]);

    useEffect(()=>{
        setErrorMessage('')
    }, [chainSelected, quantity])

    useEffect(()=>{
        if(chainSelected <= 0){ // -1 and 0
            setLockedTransfer(false)
        } else {
            const chain = findByChainId(chainSelected) || {}
            const lk = currentUser.linkedAccounts || {}
            setLockedTransfer(!lk[chain.backendReference])
        }
    }, [chainSelected, currentUser.linkedAccounts])

    // Fee % - Calculate the Fee based on the Balance & Stake
    useEffect(()=>{
        if(!balance) return;
        // formula constants
        const a = 100
        const b = 0.4
        const c = -15
        const MAX = 50

        let bal = 0 // balance
        let stk = 0 // stake
        if(balance.balance)
            bal = Number(balance.balance.split(' ')[0])
        if(balance.stake)
            stk = Number(balance.stake.split(' ')[0])
        // TODO: get the days (30 days) from (configured on qudotoken11)
        if(balance.stakeHistory && Array.isArray(balance.stakeHistory))
            balance.stakeHistory.forEach((v,i)=>{
                if(olderThan( v.timestamp, 30*24*60*60*1000 )){
                    stk -= getFloat(v.amount, 0)
                }
            })
        
        const x = stk/bal *100
        const y = a / Math.pow(x, b) + c
        
        console.log("stk", stk)
        console.log("bal", bal)
        console.log("x", x)
        console.log("y", y)

        let _fee = fee 
        try{ _fee = ceil(y, 4)
        } catch(e){console.warn(e)}

        if( _fee > MAX ) _fee = MAX

        setFee( _fee )

    },[balance])

    // Loading - If it is processing / submitting
    useEffect(() => {
        if( submitting || ( actionsList.length !== 0 ) )
            setLoading(true)
        else
            setLoading(false)
    }, [submitting, actionsList])

    // MARK: ACTIONs uEffct
    // actionsList, pausedActions
    useEffect(() => {
        if(global.isDev) console.debug('ActionsList ', JSON.parse(JSON.stringify(actionsList)));
        if(actionsPaused){
            console.debug("ActionsList paused")
            return;
        }

        if(actionsList.length === 0){
            console.debug("ActionsList empty")
            return;
        }

        const i = actionsList.findIndex( action => action.completed === false );

        if( i === -1 ) {
            console.debug('ActionsList - All actions completed')
            eth.delayedUpdateBalances(700)
            setActions()
            return
        };

        const lk = currentUser.linkedAccounts || {};

        const action = actionsList[i];
        switch (action.func) {

            case FUNC.PRINT_NETWORK:
                if(global.isDev) console.log(`[${i}] Transfer <${FUNC.BRIDGE}> - Current Network`, eth.network);
                finishAction(actionsList, i);
                return

            case FUNC.SWITCH_NETWORK:
                const targetChainId = action.args[0]
                eth.switchNetwork( targetChainId )
                .then( ()=>{
                    finishAction(actionsList, i);
                    if(global.isDev) console.log("Transfer - Switched to chainId", targetChainId);
                })
                .catch( (e)=>{
                    console.error(`[${i}] Transfer <${FUNC.SWITCH_NETWORK}> - error`, e)
                    errorAction(actionsList, i, e)
                })
                return

            case FUNC.BRIDGE:
                const source_chainId = action.options['source_chainId']
                if( source_chainId && source_chainId !== eth.network.chainId) { // Not on the correct chain
                    eth.switchNetwork( source_chainId )
                    .then( ()=>{
                        if(global.isDev) console.log(`[${i}] Transfer <${FUNC.BRIDGE}> - Switched to <${source_chainId}>`);
                        repeatAction(actionsList);
                    })
                    .catch( (e)=>{
                        console.error(`[${i}] Transfer <${FUNC.BRIDGE}> - Switch error`, e)
                        errorAction(actionsList, i, e)
                    })
                    return
                }

                // eth.wallet !== lk[here] ? error action
                const bridge__chain = findByChainId(source_chainId) || {}
                if(bridge__chain){
                    const expectedAddress = lk[bridge__chain.backendReference]
                    const currentAddress = eth.walletAddress
                    if(currentAddress !== expectedAddress){
                        console.warn(`[${i}] Transfer <${FUNC.BRIDGE}> - Wrong Address to continue <${expectedAddress}> != <${currentAddress}>`)
                        errorAction(actionsList, i, {message:<>
                            To continue, please switch on <b>MetaMask</b> to the address <b>{shortenAddress(expectedAddress,5)}</b>
                        </>
                        })
                        return
                    }
                }

                const bridge_to     = action.args[0]
                const bridge_amount = action.args[1]
                const bridge_chain  = action.args[2]
                eth.ethersBridge( bridge_to, bridge_amount, bridge_chain )
                .then( ( tx )=>{
                    if(global.isDev) console.log(`[${i}] Transfer <${FUNC.BRIDGE}> - Bridged`, tx);
                    finishAction(actionsList, i);
                })
                .catch( (e)=>{
                    console.error(`[${i}] Transfer <${FUNC.BRIDGE}> - error`, e)
                    errorAction(actionsList, i, e)
                })
                return

            case FUNC.PERMISSION:
                if( eth.network.chainId !== chains.telosEVM.chainId ){ // Not on tEVM
                    eth.switchNetwork( chains.telosEVM.chainId )
                    .then( ()=>{
                        if(global.isDev) console.log(`[${i}] Transfer <${FUNC.PERMISSION}> - Switched to EVM`);
                        repeatAction(actionsList);
                    })
                    .catch( (e)=>{
                        console.error(`[${i}] Transfer <${FUNC.PERMISSION}> - Switch error`, e)
                        errorAction(actionsList, i, e)
                    })
                    return
                } // in EVM

                // eth.wallet !== lk[here] ? error action
                if(true){
                    const expectedAddress = lk[chains.telosEVM.backendReference]
                    const currentAddress = eth.walletAddress
                    if(currentAddress !== expectedAddress){
                        console.warn(`[${i}] Transfer <${FUNC.PERMISSION}> - Wrong Address to continue <${expectedAddress}> != <${currentAddress}>`)
                        errorAction(actionsList, i, {message:<>
                            To continue, please switch on <b>MetaMask</b> to the address <b>{shortenAddress(expectedAddress,5)}</b>
                        </>
                        })
                        return
                    }
                }

                const amount = action.args[0]
                eth.permissionToBridgeBack( String(amount) )
                .then( ( tx )=>{
                    if(global.isDev) console.log(`[${i}] Transfer <${FUNC.PERMISSION}> - Permission granted`, tx);
                    finishAction(actionsList, i);
                })
                .catch( (e)=>{
                    console.error(`[${i}] Transfer <${FUNC.PERMISSION}> - error`, e)
                    errorAction(actionsList, i, e)
                })
                return

            case FUNC.BRIDGE_BACK:
                if( eth.network.chainId !== chains.telosEVM.chainId ){ // Not on tEVM
                    eth.switchNetwork( chains.telosEVM.chainId )
                    .then( ()=>{
                        if(global.isDev) console.log(`[${i}] Transfer <${FUNC.BRIDGE_BACK}> - Switched to EVM`)
                            repeatAction(actionsList)
                    })
                    .catch( (e)=>{
                        console.error(`[${i}] Transfer <${FUNC.BRIDGE_BACK}> - Switch error`, e)
                        errorAction(actionsList, i, e)
                    })
                    return
                } // in EVM

                // eth.wallet !== lk[here] ? error action
                if(true){
                    const expectedAddress = lk[chains.telosEVM.backendReference]
                    const currentAddress = eth.walletAddress
                    if(currentAddress !== expectedAddress){
                        console.warn(`[${i}] Transfer <${FUNC.PERMISSION}> - Wrong Address to continue <${expectedAddress}> != <${currentAddress}>`)
                        errorAction(actionsList, i, {message:<>
                            To continue, please switch on <b>MetaMask</b> to the address <b>{shortenAddress(expectedAddress,5)}</b>
                        </>
                        })
                        return
                    }
                }

                const amountToBridgeBack = action.args[0]
                const receiver = action.args[1]
                eth.ethersBridgeBack( String(amountToBridgeBack), receiver )
                .then( ( tx )=>{
                    if(global.isDev) console.log(`[${i}] Transfer <${FUNC.BRIDGE_BACK}> - Bridged back`, tx)
                    finishAction(actionsList, i)
                })
                .catch( (e)=>{
                    console.error(`[${i}] Transfer <${FUNC.BRIDGE_BACK}> - error`, e)
                    errorAction(actionsList, i, e)
                })
                return
            
            case FUNC.WAIT_BALANCE:
                const amountToWait  = action.args[0]
                const chainIdToWait = action.args[1]
                if( chainIdToWait !== eth.network.chainId ){ // Not on the correct chain
                    eth.switchNetwork( chainIdToWait )
                    .then( ()=>{
                        if(global.isDev) console.log(`[${i}] Transfer <${FUNC.WAIT_BALANCE}> - Switched to ${chainIdToWait}`)
                        repeatAction(actionsList)
                    })
                    .catch( (e)=>{
                        console.error(`[${i}] Transfer <${FUNC.WAIT_BALANCE}> - Switch error`, e)
                        errorAction(actionsList, i, e)
                    })
                    return
                } // in correct chain
                let balance = 0;

                const walletAddressToWait = lk[findByChainId(eth.network.chainId).backendReference]
                let intervalId = setInterval(async () => {
                    try {
                        balance = await eth.getBalanceOf(walletAddressToWait, chainIdToWait);
                        if (balance >= getFloat(amountToWait)) {
                            clearInterval(intervalId)
                            finishAction(actionsList, i)
                            return;
                        }
                    } catch (error) {
                        console.error("Error while waiting for balance update:", error);
                        clearInterval(intervalId);
                        repeatAction(actionsList)
                        return;
                    }
                }, 1000);

                const WAIT_BALANCE_timeout = action.options['timeout'] // || 60000; // default to 60 seconds
                if( WAIT_BALANCE_timeout && !isNaN(WAIT_BALANCE_timeout) ){
                    setTimeout(() => {
                        action.options['stopped'] = true;
                        console.warn("Waiting for balance timed out");
                        clearInterval(intervalId);
                    }, Number(WAIT_BALANCE_timeout));
                }

                break;

            case FUNC.MIN_CHAIN_BALANCE:
                const minAmount_minChainBalance = action.args[0]
                const chainId_minChainBalance   = action.args[1]
                const chain_minChainBalance     = findByChainId(chainId)
                
                if( chainId_minChainBalance !== eth.network.chainId ){ // Not on the correct chain
                    eth.switchNetwork( chainId_minChainBalance )
                    .then( ()=>{
                        if(global.isDev) console.log(`[${i}] Transfer <${FUNC.MIN_CHAIN_BALANCE}> - Switched to ${chain_minChainBalance.chainName}`)
                        repeatAction(actionsList)
                    })
                    .catch( (e)=>{
                        console.error(`[${i}] Transfer <${FUNC.MIN_CHAIN_BALANCE}> - Switch error`, e)
                        errorAction(actionsList, i, e)
                    })
                    return
                } // in correct chain

                // Check for tEVM wallet registed
                const tEvmWallet = lk[chain_minChainBalance.backendReference]
                if( ! tEvmWallet ){
                    setModalMessage(`You have to register an address on ${chain_minChainBalance.displayName} first`) 
                    setFailureModal(true)
                    return
                }

                // Get that native balance 
                const nbKEY = 'native_balance'
                const nativeBalance = action.options[nbKEY]
                if( nativeBalance === undefined ){ if(global.isDev)console.debug(`${FUNC.MIN_CHAIN_BALANCE} idk nativeBalance`)
                    eth.getNativeBalance( tEvmWallet )
                    .then( (b) => {
                        const balance = Number(b)
                        action.options[nbKEY] = balance
                        repeatAction(actionsList)
                    })
                    .catch( (e)=>{
                        console.error(`[${i}] Transfer <${FUNC.MIN_CHAIN_BALANCE}> - Native Balance error`, e)
                        errorAction(actionsList, i, e)
                    })
                    return
                } if(global.isDev)console.debug(`${FUNC.MIN_CHAIN_BALANCE} nativeBalance is ${nativeBalance}`)

                const hasEnough = nativeBalance > minAmount_minChainBalance
                if(global.isDev)console.debug(`${FUNC.MIN_CHAIN_BALANCE} hasEnough`, hasEnough)
                if( ! hasEnough ){
                    setModalMessage( action.options['error_message'] )
                    setFailureModal( true )
                    setActions() // clean the actions. Not enough balance = cannot do whole process
                    return
                }

                if ( hasEnough )
                    finishAction(actionsList, i)

                break

            default:
                console.error("Transfer - Unknown action", actionsList[i]);
                finishAction(actionsList, i);
                break
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [actionsList, actionsPaused])

    // MARK: ACTIONs Func
    function setActions(actions, unpause){
        if( actions === undefined ) actions = []
        localStoreAction(actions)

        if(actionsList.length === 0 && actions.length === 0) // do not set again...
            return

        if(unpause)
            setActionsPaused(false)
        
        setActionsList([...actions])
    }

    function finishAction(actions, i){
        if( actions === undefined ) actions = []
        if( i && i >= actions.length ) throw new Error("Finish Action - index out of range")
        else if( i >= 0 ){ // no i = skip
            actions[i].completed = true;
            actions[i].error = null
            if( actions[i].options['success_message'] ){
                setActionsModal( false ) // close if open
                setModalMessage( actions[i].options['success_message'] )
                setSuccessModal( true )
            }
        }

        setActions(actions)
    }

    function errorAction(actions, i, error){
        if( actions === undefined ) actions = []
        if( i && i >= actions.length ) throw new Error("Error Action - index out of range")
        else if( i >= 0 ){ // no i = skip
            setActionsPaused( true )
            actions[i].completed = false;
            actions[i].error = error.message
            if(!actionsModal){ // actionsModal closed ? show the error this way
                setModalMessage( error.message )
                setFailureModal( true )
            }
            // setActionsModal( false ) // close the actionsModal
        }

        setActions(actions)
    }

    function repeatAction(actions){
        setActions(actions)
    }

    function localStoreAction(actions){
        const currExecPosition = actions.findIndex( action => action.completed === false )
        if( currExecPosition === -1 || actions.length <= 0 ) { // actions finished OR empty ?
            localStorage.removeItem( localStorageKey )
            return
        }

        actions = JSON.parse(JSON.stringify(actions))
        for(const a of actions){ a.error=null } // don't save errors

        localStorage.setItem( localStorageKey, JSON.stringify(actions) )
    }
    

    //MARK: Functions
    const minFee = isEVM?0:100
    const minQty = isEVM?0:500

    function handlePreFeeQtyChange(val) {
        // If user enters the amount they want the recipient to get (preFeeQty),
        // calculate the required quantity to send:
        // quantity = preFeeQty / (1 - fee/100)
        const max_pFQ = round(maxBalance - floor(maxBalance*fee/100, 4), 4); console.log("MAX PFQ", max_pFQ)
        const preFeeQty = confirmAmount(val, max_pFQ, minQty-minFee)
        const quantity = Math.max( floor(preFeeQty/(100-fee)*100, 4), minQty )
        const feeQty = round(quantity-preFeeQty, 4) // with above, the 100 min fee should be forced
        setPreFeeQty(preFeeQty)
        setFeeQty(feeQty)
        setQuantity(quantity)
    }

    function handleQuantityChange(val) {
        const quantity = confirmAmount(val, maxBalance, minQty)
        const feeQty = Math.max( ceil(quantity*fee/100, 4), minFee)
        const preFeeQty = round(quantity - feeQty, 4)
        setPreFeeQty(preFeeQty)
        setFeeQty(feeQty)
        setQuantity(quantity)
    }

    const updateBalance = useCallback( ()=>{
        if(!isEVM){
            let balanceValue = 0;
            let stakeValue = 0;
            if(balance && balance.balance){
                balanceValue = Number(String(balance.balance).split(' ')[0]);
                if(balance.stake) 
                    stakeValue = Number(String(balance.stake).split(' ')[0]);
            }
            setMaxBalance(balanceValue - stakeValue);
            return;
        }
        if(isEVM){
            setMaxBalance(eth.balances[chainId]);
            return;
        }
    }, [balance, chainId, eth.balances, isEVM] )

    // MARK: submit EVM
    async function submitEVM(){
        if(global.isDev) console.log(`Send submit: EVM & Chain ID <${chainId}>`);

        const selectedChain = findByChainId(chainSelected || chains.telosEVM.chainId); // default to tEVM
        const actions = []
        const lk = currentUser.linkedAccounts || {};
        const to = lk[selectedChain.backendReference]

        if(!to){
            setErrorMessage(`Can not transfer to ${selectedChain.displayName}, as you do not have any address registered for that chain.`)
            return
        }

        if(chainId !== eth.network.chainId){
            console.error(`Send submit: Chain ID mismatch <${chainId}> != <${eth.network.chainId}> `);
            actions.push(createAction({ func: FUNC.SWITCH_NETWORK, args: [chain.chainId], }))
        }

        // Case 1 - meaning - between any EVM
        if( chainSelected !== 0 ) { 
            if(global.isDev) console.log(`Send submit: between EVMs <${chainId}> to <${chainSelected}>`);

            actions.push(createAction({
                func: FUNC.BRIDGE,
                args:[to, quantity, chainSelected],
                options:{
                    'success_message': `Success! The balance on ${selectedChain.displayName} will update after the bridging is completed`,
                    'source_chainId': chainId,
                },
                message: `Bridging to ${selectedChain.displayName}`,
            }))
            setActions(actions, true)
            return;
        } 

        // Case 2 - meaning - between any EVM to Telos Zero   -   To bridge back, into original chain
        // the selectedChain defaulted to tEVM 

        if( quantity < rules.minimum_bridge_amount ){
            setModalMessage( `Minimum amount to bridge is ${rules.minimum_bridge_amount} QUDO` );
            setFailureModal(true);
            return;
        }

        if(global.isDev) console.log(`[Transfer][submitEVM]: EVMs <${chainId}> to Telos Zero `);

        // From any chain to ZERO, we pass otherChain -> tEVM (to then tEVM -> ZERO)
        if( chainId !== chains.telosEVM.chainId ){ 
            if(global.isDev) console.log(`[Transfer][submitEVM]: EVMs <${chainId}> to Telos Zero bridge `);

            const tEVMAddress =  lk[chains.telosEVM.backendReference]
            const isAddressConnected = eth.accounts.some( a=>String(a).toLowerCase()===String(tEVMAddress).toLowerCase() )
            if( ! isAddressConnected ){
                setModalMessage( <>
                    Your wallet does not have the address <b>{shortenAddress(tEVMAddress,5)}</b> connected<br/>
                    On <b>MetaMask</b> - <u>switch</u> to it and <u>connect</u> that account<br/>
                    <br/>
                    It is needed for future steps, since it's registed on your {chains.telosEVM.displayName}
                </>);
                setFailureModal(true);
                return;
            }

            const minNative = 1 // allow ( 0.015 ) + bridge ( 0.2 fee + 0.17 ) ~= 0.4 TLOS
            actions.unshift(createAction({
                func: FUNC.MIN_CHAIN_BALANCE,
                args: [minNative, chains.telosEVM.chainId],
                options:{
                    'error_message':<>
                        Atleast <b>{Number(minNative).toFixed(4)} {chains.telosEVM.nativeCurrency.symbol}</b> on <b>{chains.telosEVM.displayName}</b> is needed to cover possible fees
                    </>,
                    'source_chainId': chainId,
                }
            }))
            
            // First bridge to Telos EVM
            actions.push(createAction({ 
                func: FUNC.BRIDGE,
                args:[to, quantity, chains.telosEVM.chainId],
                options:{'source_chainId': chainId},
                message: "Bridging to Telos EVM",
            }))
            
            actions.push(createAction({ func: FUNC.SWITCH_NETWORK, args: [chains.telosEVM.chainId], }))

            actions.push(createAction({
                func: FUNC.WAIT_BALANCE,
                args: [quantity, chains.telosEVM.chainId],
                message: `Waiting for ${quantity.toFixed(4)} QUDO on ${chains.telosEVM.displayName} `,
            }))
        }

        // Ask for permission to spend the user's tokens on the EVM Zero
        actions.push(createAction({
            func: FUNC.PERMISSION,
            args: [quantity],
            message: `Set allowance of ${quantity.toFixed(4)} QUDO to be bridge`,
        }))

        // Bridge ack the tokens to Telos Zero
        actions.push(createAction({
            func: FUNC.BRIDGE_BACK,
            args: [String(quantity), currentUser.account_name],
            message: `Bridge ${quantity.toFixed(4)} QUDO to Telos Zero`,
            options:{'success_message': `Success. You will receive your tokens on Telos Zero account in 30 to 60 seconds`},
        }))

        // Back to the original chain
        actions.push(createAction({ func: FUNC.SWITCH_NETWORK, args: [chainId], }))
        
        setActions(actions, true)
    } // bridge back to Telos Zero - completed


    // MARK: submit TLOS
    /// From TLOS -> EVMs
    async function submitTLOS(){
        // receiver should be the bridge !
        const receiver = global.isMainnet? process.env.REACT_APP_CONTRACT_ACCOUNT_ZERO_BRIDGE: process.env.REACT_APP_CONTRACT_ACCOUNT_ZERO_BRIDGE_TESTNET;
        const receiverInfo = null;
        const selectedChain = findByChainId(chainSelected);
        const lk = currentUser.linkedAccounts || {};
        const to = lk[selectedChain.backendReference]   // to address of selected chain
        const telosEVMTo = lk[chains.telosEVM.backendReference] // telos to address

        if(!telosEVMTo || telosEVMTo === ''){
            setErrorMessage(`Can not transfer to ${selectedChain.displayName}, as you do not have any address registered for ${chains.telosEVM.displayName} chain.`)
            return
        }

        if(!to || to === ''){ 
            setErrorMessage(`Can not transfer to ${selectedChain.displayName}, as you do not have any address registered for that chain.`)
            return
        }

        const actions = []
        let failed = false

        if( minBridgeBalance > await eth.getBridgerNativeBalance() ){
            setModalMessage("Not enough funds on Qudo Bridge, try again later")
            setFailureModal(true)
            return;
        }

        // CHECK if has enough NATIVE balance (TELOS) to pay for bridge
        if(chainSelected !== chains.telosEVM.chainId){ // is transefring from Zero -> to Any other EVM

            if( String(eth.walletAddress).toLowerCase() !== String(telosEVMTo).toLowerCase() ){ // Wallet opened is different that
                setErrorMessage(<>
                    Please switch <b>MetaMask</b> to the address <b>{shortenAddress(telosEVMTo,5)}</b>
                    <br/>
                    Or <b>register</b> the current one on <b>{chains.telosEVM.displayName}</b> page
                </>)
                console.log(`Current Wallet <${eth.walletAddress}> is not the same as needed <${telosEVMTo}>`)
                return
            }

            if( eth.network.chainId !== chains.telosEVM.chainId ){ // wallet not on tEVM ?
                setModalMessage(`Incorrect chain open on MetaMask. Try again`) // this can be automated with an useState
                eth.switchNetwork(chains.telosEVM.chainId) // ^ via .then(()=>{setState(1)}) and state calls this func again
                setFailureModal(true)
                return
            }
            
            if( ! telosEVMTo ){ // no tEVM registed
                setModalMessage(`You have to register an address on ${chains.telosEVM.displayName} first`) 
                setFailureModal(true)
                return
            }

            const nativeBalance = Number(await eth.getNativeBalance(telosEVMTo))
            if(global.isDev)console.debug(`User has ${nativeBalance} ${chains.telosEVM.nativeCurrency.symbol} in ${telosEVMTo}`)
            const minBalance    = await eth.quoteBridge(to, preFeeQty, chainSelected)
            if(global.isDev)console.debug(`minBalance <${typeof(minBalance)}:${minBalance}> - ${to} ${preFeeQty} ${chainSelected}`)
            if ( isNaN(minBalance) ){ // making sure it's the proper output
                setModalMessage(`Something went wrong. Try again later or contact the QUDO team`) 
                setFailureModal(true)
                return
            }

            const gasPriceFluctuationMargin = 1.05
            const hasEnoughTLOS = nativeBalance > minBalance * gasPriceFluctuationMargin
            if( ! hasEnoughTLOS ){
                setModalMessage(<>
                    Atleast <b>{minBalance.toFixed(4)} {chains.telosEVM.nativeCurrency.symbol}</b> on <b>{chains.telosEVM.displayName}</b> is required to cover bridge fees
                </>
                )
                setFailureModal(true)
                return
            }
        }

        if(currentUser.qudoManaged){
            try{
                // Already have the Metakeep released!
                if(process.env.REACT_APP_METAKEEP_RELEASED === 'true' || eligleForMetakeep(currentUser) ){
                    const account = process.env.REACT_APP_TOKENCONTRACT;
                    const actions = [{
                        "account": account,
                        "name": "transfer",
                        "authorization": [{
                            "actor": currentUser.account_name,
                            "permission": "active"
                        }],
                        "data": {
                            from: currentUser.account_name,
                            to: receiver,
                            quantity: `${Number(quantity).toFixed(4)} ${process.env.REACT_APP_TOKENNAME}`,
                            memo: `${telosEVMTo}`,
                        }
                    }];

                    const MK_signResponse = await MK.signTransaction(currentUser.email, actions, {broadcast: false})
                    //const backendSent = 
                    await QUDOServer.post(`${process.env.REACT_APP_QUDO_SERVER}/eos/send`, {
                        from: currentUser.account_name,
                        to: receiver,
                        to_username: receiverInfo ? receiverInfo.username : null,
                        quantity: quantity,
                        memo: `${telosEVMTo}`,
                        signature: MK_signResponse.unpackedTransaction,
                    }, { withCredentials: true } )
                } 
                
                else
                // Metakeep not yet released
                { // Previous version, without metakeep // TODO: DELETE WHEN METAKEEP FULLY RELEASED
                    //const backendSignedTrans = 
                    await QUDOServer.post(`${process.env.REACT_APP_QUDO_SERVER}/eos/send`, {
                        from: currentUser.account_name,
                        to: receiver,
                        to_username: receiverInfo ? receiverInfo.username : null,
                        quantity: quantity,
                        memo: `${telosEVMTo}`,
                        signature: null,
                    }, {  withCredentials: true } )
                }
            } catch(e) {
                let errorMsg = String(e.errorMessage) || String(e)
                if(errorMsg.startsWith("Error: "))
                    errorMsg.replace("Error: ",'')
                failed = true
                setModalMessage(errorMsg)
                setFailureModal(true)
            }
        } else {
            try{
                const signedData = await ual.activeUser.signTransaction({
                    actions: [{
                        account: process.env.REACT_APP_TOKENCONTRACT,
                        name: "transfer",
                        authorization: [{
                            actor: currentUser.account_name,
                            permission: "active"
                        }],
                        data: {
                            from: currentUser.account_name,
                            to: receiver,
                            quantity: `${Number(quantity).toFixed(4)} ${process.env.REACT_APP_TOKENNAME}`,
                            memo: `${telosEVMTo}`
                        }
                    }]
                }, {
                    blocksBehind: 3,
                    expireSeconds: 30,
                    broadcast: false
                });

                const signatureData = {
                    signatures: signedData.transaction.signatures,
                    packed_trx: arrayToHex(signedData.transaction.serializedTransaction)
                }
                //const backendSubmit = 
                await QUDOServer.post(`${process.env.REACT_APP_QUDO_SERVER}/eos/send`, {
                    from: currentUser.account_name,
                    to: receiver,
                    to_username: receiverInfo ? receiverInfo.username : null,
                    quantity: quantity,
                    memo: `${telosEVMTo}`,
                    signature: signatureData
                }, {
                    withCredentials: true
                })
            } catch (e) {
                console.log("Failed to sign the transfer:")
                console.error(e)
                let errorMsg = String(e.errorMessage) || String(e)
                if(errorMsg.startsWith("Error: "))
                    errorMsg.replace("Error: ",'')
                failed = true
                setModalMessage(errorMsg)
                setFailureModal(true)
            }
        }
        if(failed)
            return;

        dispatch( _actions.updateBalance() )

        // from ZERO to TEVM only ? 
        if(chainSelected === chains.telosEVM.chainId){
            setModalMessage("Success");
            setSuccessModal(true);
            return;
        }

        // Making sure the user is RLY on TLOS
        actions.push(createAction({
            func: FUNC.SWITCH_NETWORK,
            args: [chains.telosEVM.chainId],
        }))

        // Zero to tEVM : ...
        actions.push(createAction({
            func: FUNC.WAIT_BALANCE,
            args: [preFeeQty, chains.telosEVM.chainId],
            message: `Waiting for ${preFeeQty.toFixed(4)} QUDO on ${chains.telosEVM.displayName}`,
        }))
        // Zero to tEVM : Done, bridged tokens to tEVM, now they are OFTs

        actions.push(createAction({ 
            func: FUNC.BRIDGE,
            args:[to, preFeeQty, chainSelected],
            options:{
                'source_chainId': chains.telosEVM.chainId,
                'success_message': `Success. The balance on ${selectedChain.displayName} will update shortly after`,
            },
            message: `Bridge from ${chains.telosEVM.displayName} to ${selectedChain.displayName}`,
        }))

        setActions(actions, true)
    }

    // MARK: Submit

    const beforeunloadFunction = (event) => {
        console.log("beforeunload event", event);
        event.preventDefault();
        event.returnValue = 'An operation is still in progress, leaving the page may interrupt its completion. Are you sure?';
    }

    async function submit() {
        if(chainSelected === -1) { setErrorMessage("Please select a chain"); return; }
        if(quantity <= 0) { setErrorMessage("Please enter a positive amount"); return; }
        if(quantity > maxBalance) { setErrorMessage("Insufficient balance"); return; }
        
        setSubmitting(true); 
        window.addEventListener('beforeunload', beforeunloadFunction)
        dispatch(_actions.setChangePageWarning('An operation is still in progress, leaving the page may interrupt its completion. Are you sure?'))
        
        //createAction({func: FUNC.PRINT_NETWORK, message: "Switching to tZERO Network", args: [chains.telosEVM.chainId]}),

        if(isEVM) {
            await submitEVM();
        } else {
            await submitTLOS();
        }

        setSubmitting(false);
        window.removeEventListener('beforeunload', beforeunloadFunction)
        dispatch(_actions.setChangePageWarning(''))
    }

    
    // MARK: Component
    return (
    <>
        <div className="card roundcard shadow" style={{ borderColor:`${detailColor?detailColor:''}` }} >
            <div className="row px-4 pt-4 pb-2">
                <div className="col-1">
                    <img src={send} className="mr-2" alt="send"/>
                </div>
                <div className="col-10">Transfer</div>
            </div>

            {!currentUser.qudoManaged && !ual.activeUser && !isEVM ?  // TODO: Another of this to check for eth
            ( <>
            <div className="card-body px-4 pb-0 pt-3">
                Please sign in with one of the available wallets to transfer QUDO
            </div>
            <div className="card-body">
                <button
                    type="button"
                    className="std-button-active"
                    onClick={() => {
                        ual.logout();
                        ual.restart();
                        ual.showModal();
                    }}
                >
                    <div className="text-center">
                        SIGN IN
                    </div>
                </button>
                <button
                    type="button"
                    className="std-button mb-0"
                    style={{backgroundColor: '#00cc69'}}
                    onClick={() => setTutorialModal(!tutorialModal)}
                >
                    <div className="text-center">
                        HOW TO SIGN IN
                    </div>
                </button>
            </div>
            </> ) : ( <>
        
                <div className="card-body px-4 pb-4 pt-0" >
                    <div style={{margin:isMobile?'4px 0':'12px 3rem'}}>
                        <span stype={{fontWeight:'300'}}>
                            Move my tokens across my QUDO chains
                        </span>
                        <div style={{marginTop:'2rem'}} >
                            <div className={`network-selector pt-0 ${disabled||chainId === 0?'network-disabled':''}`}>
                                <label className="network-item">
                                    Telos ZERO
                                </label>
                                <input
                                    type="radio"
                                    className="my-auto"
                                    disabled={disabled||chainId === 0}
                                    checked={chainSelected === 0}
                                    onChange={() => setChainSelected(0)}
                                />
                            </div>
                            <div className={`network-selector ${disabled||chainId === chains.telosEVM.chainId?'network-disabled':''}`}>
                                <label className="network-item">
                                    Telos EVM
                                </label>
                                <input
                                    type="radio"
                                    className="my-auto"
                                    disabled={disabled||chainId === chains.telosEVM.chainId}
                                    checked={chainSelected === chains.telosEVM.chainId}
                                    onChange={() => setChainSelected(chains.telosEVM.chainId)}
                                />
                            </div>
                            <div className={`network-selector ${disabled||chainId === chains.base.chainId?'network-disabled':''}`}>
                                <label className="network-item">
                                    BASE
                                </label>
                                <input
                                    type="radio"
                                    className="my-auto"
                                    disabled={disabled||chainId === chains.base.chainId}
                                    checked={chainSelected === chains.base.chainId}
                                    onChange={() => setChainSelected(chains.base.chainId)}
                                />
                            </div>
                        </div>
                        

                        {errorMessage && (
                            <div style={{marginTop:'2rem',color: 'red', fontSize: '0.85rem'}}>
                                <div className="col-12 text-center">
                                    {errorMessage}
                                </div>
                            </div>
                        )}


                        <div style={{marginTop:'2rem'}} >
                            <div className="col-12" style={{padding:0}}>Amount</div>

                            {chainId === 0 && ( <>

                            <div className='mt-1 px-3 py-2' style={{
                                borderRadius:'8px',border:`1px solid ${cssColors.QUDO_LIGHT_GREY}`,
                                display:'flex', alignItems:'center', flexWrap:'nowrap',
                                justifyContent:'space-between',
                            }}>
                                <input
                                    type="number"
                                    name="pre_fee_qauntity"
                                    className="numbered-range-input"
                                    style={{ border: 'none', paddingLeft:'4px' }}
                                    step={0.01}
                                    value={preFeeQty}
                                    onChange={(e) => setPreFeeQty(e.target.value)}
                                    onBlur={() => handlePreFeeQtyChange(preFeeQty) /*confirmAmount(preFeeQty, maxBalance, 0, setQuantity) */}
                                />
                                <div style={{color:cssColors.QUDO_MEDIUM_GREY}}>
                                    Qudo
                                </div>
                            </div>

                            <div className='my-3 py-3' style={{
                                borderTop:`1px solid ${cssColors.QUDO_LIGHT_GREY}`,
                                borderBottom:`1px solid ${cssColors.QUDO_LIGHT_GREY}`,
                                display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'nowrap', 
                            }}>
                                <div>
                                    <b>{(()=>{let s=parseFloat(fee.toFixed(4)).toString();if(!s.includes('.')){s+='.0'};return s})()} % Fee</b>
                                    <OverlayTrigger placement="top" overlay={knowMoreTooltip}>
                                        <span onClick={()=>{setKnowMoreModal(true)}}
                                            className='pl-2' style ={{cursor:'pointer'}}
                                        >
                                            Know more
                                        </span>
                                    </OverlayTrigger>
                                </div>
                                <div style={{color:cssColors.QUDO_MEDIUM_GREY, fontWeight: 300}}>
                                    {feeQty} QUDO
                                </div>
                            </div>


                            <div className="col-12" style={{padding:0}}>Total</div>
                            </>
                            )}

                            <div> 
                            {loading ? 
                                actionsList.length > 0 ?
                                <button 
                                    type="button"
                                    className="std-button-active mt-1 px-3 py-2"
                                    style={{
                                        display:'flex',
                                        alignItems:'center',
                                        justifyContent:'space-between',
                                        gap: '8px',
                                    }}
                                    onClick={()=>{
                                        setActionsModal(true)
                                    }}
                                >
                                    SEE PROGRESS
                                    <ClipLoader color="#282725"/>
                                </button>
                                : (
                                <div className="text-center">
                                    <ClipLoader color="#282725"/>
                                </div>
                            ) : (
                                lockedTransfer 
                                ?
                                    <button
                                        onClick={() => { submit(); }}
                                        type="button"
                                        className={`mt-1 px-3 py-2 ${lockedTransfer?'std-button-deactive':'std-button-active'}`}
                                        disabled={lockedTransfer}
                                    >
                                        <div className="text-center">
                                            <div style={{ float: "left" }}>
                                                { lockedTransfer 
                                                ? `Register an Address on ${findByChainId(chainSelected)?.displayName} first to transfer`
                                                : 'TRANSFER QUDO'
                                                }
                                            </div>
                                            {   lockedTransfer ? null :
                                            <img
                                                style={{ float: "right" }}
                                                src={arrow}
                                                alt="arrow"
                                            />
                                            }
                                        </div>
                                    </button>
                                : 
                                    <div style={{
                                            height:"64px",
                                            borderRadius:"8px",
                                            border:`1px solid ${cssColors.QUDO_YELLOW}`,
                                            display:"flex",
                                            justifyContent:"space-between",
                                        }}
                                    >
                                        <div style={{
                                            display:"flex",
                                            flexDirection:"column",
                                            alignItems:"flex-start",
                                            justifyContent:"center",
                                            paddingLeft:"24px",
                                        }}>
                                            <input
                                                type="number"
                                                name="quantity"
                                                className="numbered-range-input normal-number"
                                                style={{ border: 'none' }}
                                                value={quantity}
                                                onChange={(e) => setQuantity(e.target.value)}
                                                onBlur={() => handleQuantityChange(quantity) /*confirmAmount(quantity, maxBalance, 0, setQuantity)*/ }
                                            />
                                            {/*<span style={{fontSize:"20px"}}>{quantity}</span>*/}
                                            <span style={{ fontSize:'12px', color:'#707070', paddingLeft:'4px' }}>Qudo</span>
                                        </div>
                                        <button type="button"
                                            onClick={()=>{ submit() }}
                                            style={{ 
                                                backgroundColor: cssColors.QUDO_YELLOW,
                                                color: cssColors.BLACK,
                                                width: "140px",
                                                border: "0",
                                                borderRadius:"0px 8px 8px 0px"
                                            }} 
                                            
                                        > 
                                            TRANSFER
                                        </button>
                                    </div>
                            )}
                            </div>
                            
                        </div>
                    </div>
                </div>
            </> )
            }
        </div>

        <MessageModal
            show={successModal} 
            message={modalMessage}
            hide={() => setSuccessModal(false)}
        />

        <MessageModal
            show={failureModal} 
            message={modalMessage}
            hide={() => setFailureModal(false)}
        />
        
        {tutorialModal && (
            <WalletImportTutorial
                show={tutorialModal}
                hide={() => setTutorialModal(false)}
            />
        )}

        {
            // MARK: K.More MODAL
        }
        {knowMoreModal && (
            <Modal show={knowMoreModal} onHide={() => setKnowMoreModal(false)}>
            <Modal.Header >
                <div className='w-100 text-center' id='title' style={{fontSize:'1.5rem'}} >
                    What is the Fee ?
                </div>
            </Modal.Header>
            <Modal.Body className="confirm-modal"> 
            <div style={{padding: isMobile?'0.5rem 0.75rem':'2rem 4rem'}}>
            <div className="confirm-modal-text text-center">
                <div>
                    <div style={{marginBottom:'8px'}}>
                        <h3 style={{textAlign:'left'}}>
                            Fee
                        </h3>
                        <div style={{
                            display:'flex',
                            flexDirection:'column',
                            gap:'1rem',
                            borderTop:'1px solid black',
                            padding:'1rem 0.25rem 0.5rem',
                            textAlign:'left',
                            alignItems:'flex-start',
                        }}>
                            <span>
                                The fee percentage is determined by the amount you've staked for 30 days or more (up to 50%) compared to your total balance. Higher staking results in lower fees.
                            </span>
                            <br/>
                            <span>
                                {/*<b>Math:</b> <i>Fee% = 100 / <u>ratio</u>^0.4 - 15</i>*/}
                                The minimum transfer amount is 400 QUDO<br />
                                The minimum fee amount is 100 QUDO
                            </span>
                            
                        </div>
                    </div>
                    
                    <div style={{
                        display:'flex',
                        justifyContent:'flex-end',
                        gap: '16px',
                    }}>
                        <button type="button"
                            className="std-button-active-blue transfer-modal-action-buttons"
                            onClick={()=>{
                                setKnowMoreModal(false)
                            }}
                        > Close
                        </button>
                    </div>
                </div>
            </div>
            </div>
            </Modal.Body>
            </Modal>
        )}

        {//MARK: ACTION MODAL
         }
        {actionsModal && (
            <Modal show={actionsModal} onHide={() => setActionsModal(!actionsModal)}>
            <Modal.Header >
                <div className='w-100 text-center' id='title' style={{fontSize:'1.5rem'}} >
                    {unfinishedActions ? 'Continue previous transfer ?' : 'TRANSFER PROGRESS'}
                </div>
            </Modal.Header>
            <Modal.Body className="confirm-modal">
            <div style={{padding: "2rem 4rem"}}>
            <div className="confirm-modal-text text-center">
                <div>
                    <div style={{marginBottom:'8px'}}>
                        <h3 style={{textAlign:'left'}}>Actions</h3>
                        <div style={{
                            display:'flex',
                            flexDirection:'column',
                            gap:'1rem',
                            borderTop:'1px solid black',
                            padding:'16px 4px 8px',
                        }}>
                        { actionsList.map(( a, i ) => {
                            if(!a.message || a.message.trim() === '')
                                return null

                            return(<div>
                                <div key={`${a.func}-${i}`} style={{ 
                                    display: 'flex',
                                    justifyContent: 'space-between'
                                }} >
                                    <div> {a.message} </div>
                                    <div> {
                                        i < currentExecution ? EXECUTEDMSG :
                                        i === currentExecution ?
                                            actionsPaused ? '...' : CURREXECMSG : 
                                        WAITEXECMSG 
                                    } </div>
                                </div>
                                {a.error && 
                                <div style={{
                                    fontWeight:'lighter',
                                    color:'red',
                                    float:'left',
                                }}>
                                    {a.error}
                                </div>
                                }
                            </div>) }) } 
                        </div>
                    </div>
                    
                    <div style={{
                        display:'flex',
                        justifyContent:'flex-end',
                        gap: '16px',
                    }}>
                        <button 
                            type="button"
                            className="std-button-active-red transfer-modal-action-buttons"
                            onClick={()=>{
                                setActions()
                                setActionsPaused(true)
                                setUnfinishedActions(false)
                                setActionsModal(false)
                            }}
                        >
                            {unfinishedActions ? 'Discard' : 'Abort'}
                        </button>

                        <button 
                            type="button"
                            className="std-button-active-blue transfer-modal-action-buttons"
                            onClick={()=>{
                                setUnfinishedActions(false)
                                setActionsPaused(!actionsPaused)
                            }}
                        >
                            {actionsPaused ? 'Continue' : 'Pause'}
                        </button>
                    </div>

                </div>
            </div>
            </div>
            </Modal.Body>
            </Modal>
        )}


    </>
    )
}